class Tooltip extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.addEventListener('click', this.toggleHoverState.bind(this));
    }
    toggleHoverState() {
        if (window.innerWidth >= 990) return;
        if (this.classList.contains('hover')) this.classList.remove('hover');
        else this.classList.add('hover');
    }
}
customElements.define('tooltip-component', Tooltip);